import type { TmVariant } from "@models/mappingResult";

/** Positional columns in historical TM keys and fields in new TM variants. */
export const TM_VARIANT_FIELDS = [
  "manufacturer", "model", "series_code", "model_year", "model_code",
  "engine_code", "displacement_cc", "fuel", "drive", "body", "power_kw",
  "power_hp", "cylinders", "valves", "engine_type", "fuel_mixture",
  "vehicle_type",
] as const;

/** A canonical key for option selection, deduplication and adjacent row grouping. */
export const variantIdentity = (variant: TmVariant): string => {
  if (typeof variant === "string") {
    const parts = variant.split("|");
    return parts.length === 9 || parts.length === 17 || parts.length === 19
      ? JSON.stringify(parts.slice(0, 17).map((part) => part.trim()).concat(Array(Math.max(0, 17 - parts.length)).fill("")))
      : JSON.stringify([variant]);
  }
  return JSON.stringify(TM_VARIANT_FIELDS.map((field) => variant[field]?.trim() ?? ""));
};

/** Readable display for structured and historical variants, omitting blank fields. */
export const formatVariantLabel = (variant: TmVariant): string =>
  (typeof variant === "string"
    ? variant.split("|")
    : TM_VARIANT_FIELDS.map((field) => variant[field] ?? ""))
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0)
    .join("|");

export default formatVariantLabel;
